import useSWR from "swr";
import { LINKS } from "@/content/site";
import { fetchLogbookFeed } from "@/lib/logbook";

// Only share the current response in memory. No archived posts, localStorage,
// database or build-time snapshot: Beehiiv is the sole source of article content.
const useFeed = () => useSWR(LINKS.rss, fetchLogbookFeed, {
  revalidateOnMount: true,
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  refreshInterval: 60000,
  errorRetryCount: 2,
});

export const useLogbookPosts = () => {
  const { data, error, isLoading } = useFeed();
  return {
    posts: error ? [] : data?.posts || [],
    categories: error ? [] : data?.categories || [],
    loading: isLoading,
    error: Boolean(error),
  };
};

export const useLogbookPost = (slug) => {
  const { data, error, isLoading, isValidating } = useFeed();
  const posts = data?.posts || [];
  const index = posts.findIndex((post) => post.slug === slug);
  const post = posts[index];
  const loading = isLoading || (!post && isValidating);
  const neighbor = (entry) => entry ? { slug: entry.slug, title: entry.title } : null;
  return {
    data: post && !error ? { post, newer: neighbor(posts[index - 1]), older: neighbor(posts[index + 1]) } : null,
    loading,
    error: error ? "unavailable" : !loading && !post ? "notfound" : null,
  };
};
